import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject, Component, OnInit, LOCALE_ID } from "@angular/core";
import { NgForm } from "@angular/forms";
import { DeviceDetectorService } from "ngx-device-detector";
import { FormatParameterData } from "../abstract.report.component";

export interface ReportExportDialogData {
  reportId: string;
}

@Component({
  selector: 'report.export.dialog',
  templateUrl: 'report.export.dialog.html',
  styleUrls: ['./report.export.dialog.scss']
})
export class ReportExportDialog implements OnInit {
  errors: string;
  locale: string;
  isRequesting: boolean;
  isMobile: boolean = false;

  constructor(
    @Inject(LOCALE_ID) locale: string,
    private deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<ReportExportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ReportExportDialogData) {

    this.isMobile = !this.deviceDetectorService.isDesktop();
    this.locale = locale;
  }

  ngOnInit() {
  }

  submitReportExport(form: NgForm) {
    // Not implemented
  }

  exportClick(format: FormatParameterData) {
    format.locale = this.locale;
    this.dialogRef.close(format);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
